<template>
  <div class="qb-group">
    <div class="qb-group-head">
      <a-select
        style="width: 110px"
        :value="group.type || 'and'"
        :options="[
          { label: '并且', value: 'and' },
          { label: '或者', value: 'or' },
        ]"
        @update:value="(v:string) => (group.type = v)"
      />
      <a-button
        size="small"
        @click="addRule"
      >
        添加条件
      </a-button>
      <a-button
        size="small"
        style="margin-left: 8px"
        @click="addGroup"
      >
        添加分组
      </a-button>
    </div>

    <div class="qb-group-body">
      <template
        v-for="(child, idx) in group.conditions"
        :key="idx"
      >
        <!-- 分组 -->
        <div
          v-if="child && typeof child === 'object' && 'type' in child"
          class="qb-subgroup"
        >
          <ConditionGroup
            :group="child"
            :columns="columns"
          />
          <a-button
            danger
            size="small"
            style="margin: 4px 0"
            @click="removeAt(idx)"
          >
            删除分组
          </a-button>
        </div>
        <!-- 规则 -->
        <div
          v-else
          class="qb-rule"
        >
          <a-select
            :value="child.field"
            style="min-width: 200px"
            placeholder="选择字段"
            :options="fieldOptions"
            @update:value="(v:string)=> (child.field = v)"
          />
          <a-select
            :value="child.op"
            style="width: 200px"
            :options="operators"
            @update:value="(v:string)=> (child.op = v)"
          />

          <!-- 值输入区域 -->
          <template v-if="child.op === 'in'">
            <a-select
              mode="tags"
              style="min-width: 220px"
              :value="Array.isArray(child.value) ? child.value : []"
              placeholder="输入多个值后回车"
              @update:value="(v:any)=> (child.value = v)"
            />
          </template>
          <template v-else-if="child.op === 'between'">
            <a-space :size="4">
              <a-input
                style="width: 120px"
                :value="Array.isArray(child.value) ? child.value?.[0] : undefined"
                placeholder="起始值"
                @update:value="(v:any)=> updateBetween(child, 0, v)"
              />
              <span style="padding: 0 4px; color: #999">～</span>
              <a-input
                style="width: 120px"
                :value="Array.isArray(child.value) ? child.value?.[1] : undefined"
                placeholder="结束值"
                @update:value="(v:any)=> updateBetween(child, 1, v)"
              />
            </a-space>
          </template>
          <template v-else-if="child.op === 'is'">
            <a-select
              style="min-width: 160px"
              :value="child.value"
              placeholder="选择 NULL/TRUE/FALSE"
              @update:value="(v:any)=> (child.value = v)"
            >
              <a-select-option :value="null">NULL</a-select-option>
              <a-select-option :value="true">TRUE</a-select-option>
              <a-select-option :value="false">FALSE</a-select-option>
            </a-select>
          </template>
          <template v-else>
            <a-input
              style="min-width: 220px"
              :value="child.value"
              placeholder="输入值"
              @update:value="(v:any)=> (child.value = v)"
            />
          </template>

          <a-button
            danger
            size="small"
            @click="removeAt(idx)"
          >
            删除
          </a-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'ConditionGroup',
  props: {
    group: { type: Object as any, required: true },
    columns: { type: Array as any, required: true },
    isRoot: { type: Boolean, default: false },
  },
  setup(props) {
    const operators = [
      { label: '等于', value: '=' },
      { label: '不等于', value: '!=' },
      { label: '大于', value: '>' },
      { label: '大于或等于', value: '>=' },
      { label: '小于', value: '<' },
      { label: '小于或等于', value: '<=' },
      { label: '包含', value: 'in' },
      { label: '模糊匹配', value: 'like' },
      { label: '介于', value: 'between' },
    ];

    const fieldOptions = computed(() =>
      (props.columns as any[]).map((c: any) => ({ label: c.title, value: c.dataIndex })),
    );

    const addRule = () => {
      (props.group as any).conditions.push({ field: '', op: '=', value: '' });
    };
    const addGroup = () => {
      (props.group as any).conditions.push({ type: 'and', conditions: [] });
    };
    const removeAt = (idx: number) => {
      (props.group as any).conditions.splice(idx, 1);
    };
    const updateBetween = (rule: any, pos: number, v: any) => {
      const arr = Array.isArray(rule.value) ? rule.value : [undefined, undefined];
      arr[pos] = v;
      rule.value = arr;
    };

    return {
      operators,
      fieldOptions,
      addRule,
      addGroup,
      removeAt,
      updateBetween,
    };
  },
});
</script>

<style lang="less" scoped>
.qb-group {
  border-left: 2px solid #f0f0f0;
  padding-left: 8px;
}
.qb-group-head {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.qb-group-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.qb-rule {
  display: flex;
  align-items: center;
  gap: 8px;
}
.qb-subgroup {
  padding: 6px 0 6px 8px;
  border-left: 2px dashed #f0f0f0;
}
</style>
